<template>
  <span class="row">
    <dt class="col-4">{{ title }}</dt>
    <dd class="col-8" v-if="input.length > 0" v-html="input"></dd>
    <dd class="col-8" v-else>N/A</dd>

  </span>
</template>
<script type="text/javascript">
export default {
  name: 'ProfileRow',
  props: {
    title: {
      type: String,
      required: true
    },
    value: {
      type: [String, Number],
      required: true
    }
  },
  computed: {
    input() {
        return this.value.toString();
    }
  }
}

</script>



// WEBPACK FOOTER //
// src/My/components/Profile/ProfileRow.vue